<bp-error-shell>
	<div class="ng-content-title-error-code">404</div>

	<div class="ng-content-description">Sorry, the page you are trying to reach was not found</div>

	<div class="ng-content-error-image">
		<bp-img url="/assets/error/broken-card.png"></bp-img>
	</div>
</bp-error-shell>
